angular.module('unica_feedback.feedback_services')

	.factory('FeedbackEditService', function ($http, getBaseApiURL) {

		var feedbackListService = {};

		feedbackListService.update = function (feedbackData) {

			return $http({
				method: 'POST',
				url: getBaseApiURL + '/feedback/update/' + feedbackData.id,
				data: feedbackData
			}).then(function(result) {

				if ( result ) {
					return result.data.feedback;
				}

			});

		};


		feedbackListService.sendNotifications = function (feedbackData)
		{
			return $http({
				method: 'POST',
				url: getBaseApiURL + '/feedback/send-notifications',
				data: feedbackData
			}).then(function(result) {

				if ( result ) {
					return result.data;
				}

			});

		};


		feedbackListService.getPresignedUrlPUT = function (feedbackId, fileAWS)
		{

			return $http({
				method: 'POST',
				url: getBaseApiURL + '/feedback/preupload-media/' + feedbackId,
				data: {
					name: fileAWS.name,
					type: fileAWS.type
				}
			}).then(function(result) {

				if ( result ) {
					return result.data.info;
				}

			});

		};

		feedbackListService.getPresignedUrlGET = function (id)
		{

			return $http({
				method: 'GET',
				url: getBaseApiURL + '/feedback/url-media/' + id,
			}).then(function(result) {

			});

		};

		feedbackListService.saveMedia = function (feedbackId, fileAWS)
		{
			return $http({
				method: 'POST',
				url: getBaseApiURL + '/feedback/save-media/' + feedbackId,
				data: {
					feedbackId: feedbackId,
					awsName: fileAWS.awsName,
					name: fileAWS.name,
					type: fileAWS.type,
					thumb: fileAWS.thumb,
				}
			}).then(function(result) {

				if ( result ) {
					return result.data.url;
				}

			});

		};

		feedbackListService.removeMedia = function (feedbackId)
		{
			return $http({
				method: 'POST',
				url: getBaseApiURL + '/feedback/remove-media/' + feedbackId,
				data: {}
			}).then(function(result) {

				if ( result ) {
					return result.data.feedback;
				}

			});

		};


		return feedbackListService;
	});